<template>
  <div>
    <div id="refreshButtonWrapper">
      <v-btn style="width: 150px" class="mr-2" color="#dfe4ee" @click="getData()" :loading="refreshing">
        <v-icon class="mr-2" color="#8e9298">mdi-refresh</v-icon>
        <span color="#8e9298">{{ $t("refresh") }}</span>
      </v-btn>
    </div>
    <v-data-table :headers="headers" :items="list" :items-per-page="pageOptions.itemsPerPage" disable-sort class="tbl-list" :footer-props="footerProps" :no-results-text="$t('no_result_found')" :no-data-text="$t('no_data_found')" :options.sync="pageOptions" :server-items-length="totalItems" @update:page="onPageChanged" @update:items-per-page="onItemsPerPageChanged">
      <template v-slot:header>
        <tr>
          <td></td>
          <td v-if="showSelect"></td>
          <td>
            <v-text-field v-model="searchTckn" :label="$t('tckn')" class="mx-4" @keyup="inputKeyUp" :maxlength="11"></v-text-field>
          </td>
          <td>
            <v-autocomplete v-model="leadIds" :items="leadPartyNameList" clearable multiple item-text="fullName" item-value="id" :label="$t('fullName')" class="mx-4" @change="onLeadPartyFilterChanged" :search-input.sync="leadPartySearch" :no-data-text="$t('no_data_found')"></v-autocomplete>
          </td>
          <td colspan="1"></td>
          <td>
            <v-select class="mx-4" v-model="searchUnitCode" :items="unitCodeItems" :disabled="searchUnitCodeDisabled" :label="$t('consultantUnit')" @change="inputKeyUp" :no-data-text="$t('no_data_found')" clearable></v-select>
          </td>
          <td>
            <v-select v-model="searchAssignedName" :items="consultantItems" :label="$t('investmentConsultant')" class="mx-4" @change="inputKeyUp" :no-data-text="$t('no_data_found')" clearable></v-select>
          </td>
          <td colspan="1"></td>
          <td>
            <v-select class="mx-4" v-model="applicationName" :items="applicationNameItems" :disabled="applicationNameDisabled" :label="$t('applicationInformation')" @change="inputKeyUp" :no-data-text="$t('no_data_found')" clearable></v-select>
          </td>
        </tr>
      </template>
      <template #item="{ item }">
        <tr :key="'rd_' + item.id" :class="'row-data' + ' ' + 'row_' + item.id" @mouseenter="onMouseEnterRow($el.querySelectorAll('.row_' + item.id))" @mouseleave="onMouseLeaveRow($el.querySelectorAll('.row_' + item.id))">
          <td v-if="showSelect">
            <v-checkbox v-model="item.checked" @change="onCheckboxChanged"></v-checkbox>
          </td>
          <td>
            <v-btn icon @click="onClickCustomerCard(item.id, item.tckn, item.processId)">
              <v-icon :color="
                  item.riskGroupDTO && item.riskGroupDTO.colorCode
                    ? item.riskGroupDTO.colorCode
                    : 'blue darken-2'
                " size="32">mdi-account-search</v-icon>
            </v-btn>
          </td>
          <td>{{ item.tckn }}</td>
          <td>{{ item.fullName }}</td>
          <td>{{ formatStatusField(item.partyStatus) }}</td>
          <td>{{ getAssigneeUser(item.assigneeId).unitType }}</td>
          <td>{{ getAssigneeUser(item.assigneeId).fullName }}</td>
          <td>{{ $t(item.channel) }}</td>
          <td>{{ $t(item.onboardingProcessApplication.description) }}</td>
          <td>{{ $t(item.meetingChoice) }}</td>
        </tr>

        <tr :key="'ra_' + item.id" :class="'row-actions' + ' ' + 'row_' + item.id" @mouseenter="onMouseEnterRow($el.querySelectorAll('.row_' + item.id))" @mouseleave="onMouseLeaveRow($el.querySelectorAll('.row_' + item.id))" @click="clearProcessId">
          <td :colspan="headers.length">
            <div class="adjust-right" v-if="item.showChooseProcess">
              <v-btn outlined id="btn-choose-process" class="action" @click="onClickChooseProcess(item.id)">
                {{ $t("chooseProcess") }}
              </v-btn>
            </div>
            <div class="adjust-right" v-if="item.showDropAssignee">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" outlined @click="onClickDropAssignee(item.processId, item.leadParty.id)">
                    <v-icon>mdi-keyboard-return</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("dropAssignee") }}</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import LeadPartyListTable from "./mixin/LeadPartyListTable";
import PartyProcessListTableCommon from "./mixin/PartyProcessListTableCommon";

export default {
  mixins: [LeadPartyListTable, PartyProcessListTableCommon]
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;
$rowBackgroundColor: #dfe4ee;
$hoverColor: #eeeeee;

#refreshButtonWrapper {
  text-align: end;
  margin-bottom: 1%;
}
.tbl-list /deep/ {
  margin-top: 5%;

  tbody tr {
    background-color: $rowBackgroundColor;
    &:nth-child(4n + 3) {
      background-color: white;
    }
    &:nth-child(4n + 4) {
      background-color: white;
    }
    &.hovered {
      background-color: $hoverColor;
    }
    &.row-data {
      td {
        border-bottom: none !important;
      }
    }
    &.row-actions {
      .contact-management-column {
        text-align: start;
      }
      td {
        padding-top: 30px !important;
        padding-bottom: 10px !important;
      }
    }
  }
}
.action {
  width: 100%;
  border-color: $primaryColor;
  color: $primaryColor;
  font-weight: bold;
}
.v-btn {
  text-transform: none;
}
.adjust-right {
  float: right;
  margin: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/LeadPartyListTable.vue